import { useEffect } from 'react';

import PropTypes from 'prop-types';

import AppleIcon from '@mui/icons-material/Apple';
import { Box } from '@mui/material';

import env from '../../../env';
import { captureException } from '../../sentryInit';
import { AppleButton } from '../Button';

const AppleLogin = (props) => {
  const { signInWithApple, appleButtonLabel } = props;

  const { APPLE_CLIENT_ID, APPLE_REDIRECT_URI } = env;

  useEffect(() => {
    window.AppleID?.auth?.init({
      clientId: APPLE_CLIENT_ID,
      redirectURI: APPLE_REDIRECT_URI,
      usePopup: true,
    });
  }, []);

  const onSignInWithApple = async () => {
    try {
      const data = await window.AppleID.auth.signIn();
      const token = data?.authorization?.id_token;
      return signInWithApple(token);
    } catch (error) {
      return captureException(error);
    }
  };

  return (
    <AppleButton
      type="button"
      variant="contained"
      color="primary"
      disableElevation
      disableRipple
      onClick={() => onSignInWithApple()}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="0.5rem"
      >
        <AppleIcon fontSize="small" />
        {appleButtonLabel}
      </Box>
    </AppleButton>
  );
};

AppleLogin.propTypes = {
  signInWithApple: PropTypes.func.isRequired,
  appleButtonLabel: PropTypes.string.isRequired,
};

export default AppleLogin;
